import { css } from 'styled-components';

import { cvar } from '@/styles/GlobalStyle';

export const focusVisible = css`
  &:focus-visible {
    outline: 2px solid ${cvar('color-focus')};
    outline-offset: 2px;
  }
`;

export const focusVisibleInset = css`
  &:focus-visible {
    outline: 2px solid ${cvar('color-focus')};
    outline-offset: -2px;
  }
`;
